import React, { useState } from "react";
import "./CustomerRegistration.css"; // ✅ Import CSS
import { AiOutlineClose } from "react-icons/ai";
import { registerCustomer } from "../../services/customerService";
import { validateNIC, validateName, validateDOB, validateAddress, validatePhoneNumber } from "../../utils/validators"; // ✅ Import validation
import Popup from "../../components/ui/Popup"; // ✅ Import Popup Component

function CustomerRegistration({ isOpen, onClose, onCustomerAdded }) {
    const [formData, setFormData] = useState({
        nic: "",
        firstName: "",
        lastName: "",
        dob: "",
        gender: "Male",
        address: "",
        contactNumber: "",
    });

    const [errors, setErrors] = useState({});
    const [popupMessage, setPopupMessage] = useState("");
    const [popupType, setPopupType] = useState("");

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};

        // ✅ Validate each field
        //if (!validateNIC(formData.nic)) newErrors.nic = "Invalid NIC format!";
        if (!validateName(formData.firstName)) newErrors.firstName = "First name must contain only letters (3-50 chars).";
        if (!validateName(formData.lastName)) newErrors.lastName = "Last name must contain only letters (3-50 chars).";
        if (!validateDOB(formData.dob)) newErrors.dob = "Invalid date of birth!";
        if (!validateAddress(formData.address)) newErrors.address = "Address must be between 5-100 characters.";
        if (!validatePhoneNumber(formData.contactNumber)) newErrors.contactNumber = "Invalid phone number format (e.g., 0712345678).";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        try {
            const response = await registerCustomer(formData);
            setPopupMessage(response.message || "Customer added successfully!");
            setPopupType("success");
            setTimeout(() => {
                setPopupMessage("");
                onCustomerAdded();
                onClose();
            }, 2000);
        } catch (error) {
            setPopupMessage(error.message || "Registration failed!");
            setPopupType("error");
        }
    };

    if (!isOpen) return null;

    return (
        <div className="customer-modal">
            <div className="customer-modal-content">
                <span className="customer-close-btn" onClick={onClose}>
                    <AiOutlineClose />
                </span>
                <h2 className="customer-title">Register Customer</h2>

                {/* ✅ Popup for Success/Error Messages */}
                <Popup message={popupMessage} type={popupType} onClose={() => setPopupMessage("")} />

                <form onSubmit={handleSubmit}>
                    {/* ✅ NIC Field */}
                    <div className="customer-form-group">
                        <label>Customer NIC:</label>
                        <input type="text" name="nic" placeholder="NIC" value={formData.nic} onChange={handleChange} required />
                        {errors.nic && <span className="customer-error">{errors.nic}</span>}
                    </div>

                    {/* ✅ First Name & Last Name Side by Side */}
                    <div className="customer-name-container">
                        <div className="customer-form-group">
                            <label>First Name:</label>
                            <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required />
                            {errors.firstName && <span className="customer-error">{errors.firstName}</span>}
                        </div>

                        <div className="customer-form-group">
                            <label>Last Name:</label>
                            <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required />
                            {errors.lastName && <span className="customer-error">{errors.lastName}</span>}
                        </div>
                    </div>

                    <div className="customer-form-group">
                        <label>Date of Birth:</label>
                        <input type="date" name="dob" value={formData.dob} onChange={handleChange} required />
                        {errors.dob && <span className="customer-error">{errors.dob}</span>}
                    </div>

                    <div className="customer-form-group">
                        <label>Gender:</label>
                        <select name="gender" value={formData.gender} onChange={handleChange}>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                        </select>
                    </div>

                    <div className="customer-form-group">
                        <label>Address:</label>
                        <input type="text" name="address" placeholder="Address" value={formData.address} onChange={handleChange} required />
                        {errors.address && <span className="customer-error">{errors.address}</span>}
                    </div>

                    <div className="customer-form-group">
                        <label>Contact Number:</label>
                        <input type="tel" name="contactNumber" placeholder="Contact Number" value={formData.contactNumber} onChange={handleChange} required />
                        {errors.contactNumber && <span className="customer-error">{errors.contactNumber}</span>}
                    </div>

                    {/* ✅ Register Button */}
                    <div className="customer-register-btn-container">
                        <button type="submit" className="customer-register-btn">Register</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CustomerRegistration;
